module.exports = __webpack_public_path__ + "img/image5.08b57273.jpg";